import { useMemo } from "react";
import { useWalletContext } from "../store";
import { HeartbeatLogger } from "../utils/classes/HeartbeatLogger";
export const useHeartbeatLogger = () => {
    const { state } = useWalletContext();
    return useMemo(() => new HeartbeatLogger(state.activeWallet, state.options?.debug), [state.activeWallet, state.options?.debug]);
};
//# sourceMappingURL=useHeartbeatLogger.js.map